export default __webpack_public_path__ + "static/favicon-a3a3094d15725a0d3901104813b6b7f0.ico";